import { render, staticRenderFns } from "./bjOffer.vue?vue&type=template&id=4d04fbdb&scoped=true&"
import script from "./bjOffer.vue?vue&type=script&lang=js&"
export * from "./bjOffer.vue?vue&type=script&lang=js&"
import style0 from "./bjOffer.vue?vue&type=style&index=0&id=4d04fbdb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d04fbdb",
  null
  
)

export default component.exports